<template>
  <div class="KPI">
    <el-select v-model="LastDay" placeholder="请选择结算时间" @change="selextTime" style="padding:10px 0;">
      <el-option v-for="(item,index) in KpiDayList" :key="index" :label="item" :value="item"></el-option>
    </el-select>
    <el-table
      :data="tableData"
      style="width: 100%"
      height="84%"
      :row-style="{height:'30'}"
      :header-cell-style="{background:'rgb(100, 168, 165)',color:'#fff'}"
      :default-sort = "{prop: 'depart_abbr'}"
    >
      <el-table-column align="center" label="人员ID" min-width="80" prop="employee_id" key="1" default-sort></el-table-column>
      <el-table-column align="center" label="部门" min-width="80" prop="depart_abbr" key="2"></el-table-column>
      <el-table-column align="center" label="姓名" min-width="100" prop="employee_name" key="3"></el-table-column>

      <el-table-column align="center" label="总时长" min-width="100" prop="total_hours" key="4"></el-table-column>
      <el-table-column
        align="center"
        label="未支付总时长"
        min-width="100"
        prop="total_not_payed_hours"
        key="5"
      ></el-table-column>
      <el-table-column
        align="center"
        label="已支付总时长"
        min-width="100"
        prop="total_payed_hours"
        key="6"
      ></el-table-column>

      <el-table-column
        align="center"
        label="公司总时长"
        min-width="100"
        prop="company_total_hours"
        key="7"
      ></el-table-column>
      <el-table-column
        align="center"
        label="公司未支付"
        min-width="100"
        prop="company_total_not_payed_hours"
        key="8"
      ></el-table-column>
      <el-table-column
        align="center"
        label="公司已支付"
        min-width="100"
        prop="company_total_payed_hours"
        key="9"
      ></el-table-column>
      <el-table-column align="center" label="调休无抵扣" min-width="110" prop="daysoff_hours" key="10"></el-table-column>

      <el-table-column
        align="center"
        label="项目总时长"
        min-width="100"
        prop="project_total_hours"
        key="11"
      ></el-table-column>
      <el-table-column
        align="center"
        label="项目未支付"
        min-width="100"
        prop="project_total_not_payed_hours"
        key="12"
      ></el-table-column>
      <el-table-column
        align="center"
        label="项目已支付"
        min-width="100"
        prop="project_total_payed_hours"
        key="13"
      ></el-table-column>

      <el-table-column
        align="center"
        label="加班总时长"
        min-width="100"
        prop="overtime_total_hours"
        key="14"
      ></el-table-column>
      <el-table-column
        align="center"
        label="加班未使用"
        min-width="100"
        prop="overtime_total_not_used_hours"
        key="15"
      ></el-table-column>
      <el-table-column
        align="center"
        label="加班已使用"
        min-width="100"
        prop="overtime_total_used_hours"
        key="16"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from "axios";
import { getuserInfo } from "@/lib/until";
import { showLoading, hideLoading } from "@/lib/loading";
export default {
  name: "",
  data() {
    return {
      tableData: [],
      KpiDayList: [],
      LastDay: ""
    };
  },
  mounted() {
    this.getKPIday();
  },

  methods: {
    getKPIday() {
      axios
        .get(IPConfig.IP + "/kpi-management/ppdata/paydate.php")
        .then(res => {
          //console.log(res.data);
          if (0 == res.data.errcode) {
            if (
              res.data.payment_create_dates &&
              res.data.payment_create_dates.length > 0
            ) {
              this.KpiDayList = res.data.payment_create_dates;
              this.LastDay = this.KpiDayList[0];
              //console.log(this.KpiDayList[this.KpiDayList.length-1]);
              this.getKpiTime(this.LastDay);
            }
          }
        })
        .catch(error => {
          //console.log(error);
        });
    },
    getKpiTime(date) {
      showLoading();
      var getInfo = getuserInfo();
      axios
        .get(IPConfig.IP + "/kpi-management/ppdata/all_summary.php", {
          params: {
            // employee_id: getInfo.employee_id,
            payment_create_date: date
          }
        })
        .then(res => {
          //console.log(res.data);
          if (0 == res.data.errcode) {
            let searchList = res.data.all_summary;
            this.tableData = Object.values(searchList);
            //console.log(this.tableData);
          }
        })
        .catch(error => {
          //console.log(error);
          hideLoading();
        });
      hideLoading();
    },
    selextTime() {
      // console.log(this.LastDay);
      this.getKpiTime(this.LastDay);
    }
  }
};
</script>

<style scoped>
.KPI {
  padding: 0 30px;
  background-color: #f0f2f5;
  position: relative;
  height: 100%;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #fff;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  margin-top: 20px;
  margin-bottom: 30px;
  border-radius: 4px;
  min-height: 84px;
  /* cursor: pointer; */
  font-size: 22px;
  position: relative;
  overflow: hidden;
  color: #666;

  -webkit-box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
  box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.05);
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-divider__text {
  /* background-color:#13ce66; */
  background-color: #d1e9ff;
  padding: 6px 20px;
  color: #666;
  font-size: 18px;
}
.el-divider--horizontal {
  margin: 30px 0;
}
.chart-wrapper {
  background: #fff;
  padding: 16px 16px 0;
  margin-bottom: 32px;
  min-height: 206px;
}
.flexcolum {
  flex-direction: column;
  display: flex;
  justify-content: center;
}
.projectZj {
  text-align: left;
}
.projectText {
  padding: 10px;
  font-size: 20px;
}
.xmyandwtime {
  padding: 20px 0;
}
.titleText {
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/views/allKpiTime/index.vue